export default {
  name: 'CSVIcon',
  props: {
    width: {
      type: Number,
      default: 23
    },
    height: {
      type: Number,
      default: 23
    },
    color: {
      type: String,
      default: '#22863D'
    }
  }
};